import { Box, Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { bvdApiClient } from 'utils/bvdApiClient';
import { RatingValue } from '../renderRating';

interface PartnerRatingsProps {
  value: any;
}

const PartnerRatingsValue = ({
  value: { partnerUuid },
}: PartnerRatingsProps) => {
  const { locale } = useRouter();

  const { isLoading: isLoadingProduct, data } = useQuery(
    ['partners'],
    () => bvdApiClient(locale).userSells.partners.getAllEnabled(),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    }
  );

  const partner = useMemo(
    () => data?.payload.find((item: any) => item.uuid === partnerUuid),
    [partnerUuid, data]
  );

  if (!partner) return <></>;
  return <RatingValue value={partner.averageRatingScore} name={partner.name} />;
};

export function renderPartnerRatings(
  params: GridRenderCellParams<number, any, any>
) {
  if (params.rowNode.isAutoGenerated || params.value == null) {
    return '';
  }

  return <PartnerRatingsValue value={params.value} />;
}
